
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			getDataList:`post ${process.env.VUE_APP_API_ROOT}plate/queryDemandList.htm `,
			getVipInfo: `/apis/moyin-account/v1/vip/status`,
			// 检查token状态
			checkTokenStatus: `get https://passport.mobvoi.com/user/info/token`,
			getExtractDurationList: `get /apis/moyin-tool/v1/subtitles/extractList`,
			deleteExtractDuration: `get /apis/moyin-tool/v1/videoToAudio/deleteExtractDuration`,
			getFunctionList: {
				custom: true,
				url: (data:any)=>`/apis/tts-web-api/v1/app/functionSwitchConfig/allFunctionSwitch?`,
				method: 'get'
			},
			delteTaskId: {
				custom: true,
				url: (data:any)=>`/apis/moyin-tool/v1/subtitles/asyncExtract/${data.taskId}`,
				method: 'delete'
			},
			asyncResult: `get /apis/moyin-tool/v1/subtitles/asyncResult`,

		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"extraListPage"
			})
		}